import React from "react";
import { Box, Grid } from "@mui/joy";
import DarkInput from "../../common/DarkInput";
import type { Dispatch, SetStateAction } from "react";

type PhoneComponentProps = {
  phonenumber: string;
  setPhonenumber: Dispatch<SetStateAction<string>>;
};

export default function PhoneComponent(props: PhoneComponentProps) {
  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.replace(/[^\d+]/g, "");
    props.setPhonenumber(inputValue);
  };

  return (
    <Box sx={{ padding: 1 }}>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <DarkInput
            placeholder="+262....."
            value={props.phonenumber || ""}
            onChange={handlePhoneChange}
            sx={{ marginTop: "10px", width: "100%" }}
            inputMode="tel"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
